<template>
    <menu_items :menu_items="menu_items"
                initial_item="acute_aquatic_toxicity"
    />
</template>

<script>

import menu_items from '../../components/menu.vue';
import acute_aquatic_toxicity from './_1_acute_aquatic_toxicity/index';
import chronicle_aquatic_toxicity from './_2_chronicle_aquatic_toxicity/index';
import dangers_to_the_ozone_layer from './_3_dangers_to_the_ozone_layer/index';

export default {
    name: 'index',
    components: {
        menu_items,
        acute_aquatic_toxicity,
        chronicle_aquatic_toxicity,
        dangers_to_the_ozone_layer
    },
    data() {
        return {
            menu_items: [
                {
                    name: 'acute_aquatic_toxicity',
                    text: 'Peligro para el medio ambiente acuático - peligro a corto plazo',
                    component: acute_aquatic_toxicity,
                    image: 'AMBIENTE.png'
                },
                {
                    name: 'chronicle_aquatic_toxicity',
                    text: 'Peligro para el medio ambiente acuático - peligro a largo plazo',
                    component: chronicle_aquatic_toxicity,
                    image: 'AMBIENTE.png'
                },
                {
                    name: 'dangers_to_the_ozone_layer',
                    text: 'Peligros para la capa de ozono',
                    component: dangers_to_the_ozone_layer,
                    image: 'SIGNO_DE_EXCLAMACION.png'
                }
            ],
        };
    }
};
</script>

<style>

</style>
